import { toggleClass, toggleAttribute } from '../../assets/js/utility';

class Header {
  constructor() {
    this.menuIcon = document.querySelector('#mobile-menu-icon');

    if (this.menuIcon) {
      this.menuIcon.addEventListener('click', () => {
        toggleClass(this.menuIcon, 'is-open');
        toggleAttribute(this.menuIcon, 'aria-expanded');
      });
    }
  }
}
export default Header;
